import React, {Component, ReactNode} from 'react'
import EventEmitterExAdmin from '../../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminDialog} from '../../../../../components/shared/pageBaseComponents/AdminDialog'
import {
    ApplyAlertButton,
    ApplyDialogActions,
    FormLabelContainer,
    OutlinedTextArea,
    StyledApplyFormLabel,
    StyledHeader,
    StyledHeadingHr,
    StyledPageFooterArea
} from './NatAdminApplicationCommon'
import {RequiredChip} from '../../../../../styledComponents/adminPage/Table'
import {NotifyDialogTitle} from '../../../../../components/assocDirector/AssocDirectorCommon'
import {RowFlexContainer} from '../../../../../styledComponents/FlexComponents'
import {Box, DialogContent, Typography} from '@mui/material'
import {DialogCloseButton} from '../../../../../components/reservations/components/CommonStyle'
import {Close} from '@mui/icons-material'
import {PageFotterAreaRight} from '../../../../../components/shared/hoc/withAdminPageTemplate'
import {AppAdminContext} from '../../../../../app/AppAdminContext'
import {StyledPre} from '../../../../../styledComponents/adminPage/StyledPre'
import PPSelect from '../../../../../components/shared/forms/PPSelect'
import {addEmptyData, NoSelectedValue} from '../../../../../componentHelper/selectHelper'
import {USER_REGISTRATION_APPLY_REJECT_REASON} from '../../../../../CodeMaster'
import {SelectChangeEvent} from '@mui/material/Select';

interface Props {
    open: boolean
    onChange: (value: string) => void
    onRejection: () => Promise<void>
    onCancel: () => void
    eventEmitter: EventEmitterExAdmin
}

interface State {
    comment: string
    rejectionButtonDisabled: boolean
    selectedRejectionReason: string
}

const SELECTED_REJECTION_REASON_MISMATCH: string = '氏名または口座番号が確認できませんでした。'
const SELECTED_REJECTION_REASON_NEW_REGISTER: string = '申請可能なIDが存在しません。管理事務室までお申し出ください。管理員不在の場合は素敵生活サービスデスク（0120-875-532）にお問い合わせください。'
const SELECTED_REJECTION_REASON_SUB_USER: string = '区分所有者様からの申請を有効とさせていただきます。ご家族の方はサブユーザとしてご登録をお願いいたします。'
const SELECTED_REJECTION_REASON_BEFORE_PERIOD: string = '貴マンションは素敵ネットの利用開始前のため、開始決定後に改めてご案内いたします。'
const SELECTED_REJECTION_REASON_SMOOTH_E: string = '本マンションはsmooth-e対象マンションとなりますので、別途担当部署よりご案内申し上げます。'

export default class NatAdminUserRegistrationApplyRejectionDialog extends Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props)
        this.state = {
            comment: '',
            rejectionButtonDisabled: true,
            selectedRejectionReason: '',
        }

        this.handleMemoChange = this.handleMemoChange.bind(this)
        this.changeSelectedRejectionReason = this.changeSelectedRejectionReason.bind(this);
    }

    componentDidUpdate(prevProps: Props): void {
        if (prevProps.open !== this.props.open) {
            this.setState({
                comment: '',
                rejectionButtonDisabled: true,
            })
        }
    }

    handleMemoChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({comment: event.target.value}, () => {
            this.props.onChange(this.state.comment)
            this.updateRejectionButtonDisabled()
        })
    }

    changeSelectedRejectionReason = (event: SelectChangeEvent<unknown>, _child: React.ReactNode): void => {

        let comment: string;
        if (event.target.value === NoSelectedValue) {
            comment = '';
        } else {
            USER_REGISTRATION_APPLY_REJECT_REASON.codeToEnumConstants(event.target.value as string)
            switch (event.target.value) {
                case USER_REGISTRATION_APPLY_REJECT_REASON.MISMATCH.value :
                    comment = SELECTED_REJECTION_REASON_MISMATCH;
                    break
                case USER_REGISTRATION_APPLY_REJECT_REASON.NEW_REGISTER.value :
                    comment = SELECTED_REJECTION_REASON_NEW_REGISTER;
                    break
                case USER_REGISTRATION_APPLY_REJECT_REASON.SUB_USER.value :
                    comment = SELECTED_REJECTION_REASON_SUB_USER;
                    break
                case USER_REGISTRATION_APPLY_REJECT_REASON.BEFORE_PERIOD.value :
                    comment = SELECTED_REJECTION_REASON_BEFORE_PERIOD;
                    break
                case USER_REGISTRATION_APPLY_REJECT_REASON.SMOOTH_E.value :
                    comment = SELECTED_REJECTION_REASON_SMOOTH_E
                    break
                default :
                    comment = '';
            }
        }
        this.setState({selectedRejectionReason: event.target.value as string, comment: comment}, () => {
            this.props.onChange(this.state.comment)
            this.updateRejectionButtonDisabled()
        })
    }

    updateRejectionButtonDisabled(): void {
        const {comment} = this.state
        if (comment) {
            this.setState({rejectionButtonDisabled: false})
        } else {
            this.setState({rejectionButtonDisabled: true})
        }
    }

    renderDialogContent(): ReactNode {
        const {comment} = this.state

        return <>
            <Box mb={'16px'}>
                <StyledPre>
                    <div>この申請を却下します。</div>
                    <div>却下操作の取り消しはできません。申請内容に見落としがないか十分にご確認ください。</div>
                </StyledPre>
            </Box>
            <FormLabelContainer>
                <StyledApplyFormLabel>
                    却下理由
                </StyledApplyFormLabel>
                <Box ml={'4px'}><RequiredChip label={'必須'}/></Box>
            </FormLabelContainer>
            <PPSelect
                data={
                    addEmptyData(USER_REGISTRATION_APPLY_REJECT_REASON.values(),
                        '選択なし'
                    )}
                onChange={this.changeSelectedRejectionReason}
                eventKeys={['selectedRejectionReason']}
                eventEmitter={this.props.eventEmitter}
                value={this.state.selectedRejectionReason}
            />
            <Box mb={'8px'}></Box>
            <OutlinedTextArea
                InputProps={{
                    inputProps: {
                        maxLength: 200,
                        minRows: 6,
                    },
                }}
                required
                fullWidth
                multiline
                value={comment}
                placeholder={'200文字以内'}
                eventKeys={['rejectionReason']}
                eventEmitter={this.props.eventEmitter}
                onChange={this.handleMemoChange}
            />
            <Box mt={'8px'} fontSize={'12px'}>
                ・申請者は、メールや申請履歴から却下理由を確認することができます。<br/>
                ・申請却下後は却下理由を編集・削除することができません。ご注意ください。
            </Box>
        </>
    }

    render(): ReactNode {
        const {onRejection, onCancel} = this.props

        return (
            <AdminDialog maxWidth={'md'} open={this.props.open}>
                <Box width={'750px'}>
                    <NotifyDialogTitle>
                        <StyledHeader>
                            <RowFlexContainer>
                                <Typography variant="h5" display={'inline'}>
                                    申請の却下
                                </Typography>
                                <DialogCloseButton onClick={onCancel} id={'close'}>
                                    <Close/>
                                </DialogCloseButton>
                            </RowFlexContainer>
                        </StyledHeader>
                        <StyledHeadingHr/>
                    </NotifyDialogTitle>
                    <DialogContent>{this.renderDialogContent()}</DialogContent>
                    <ApplyDialogActions>
                        <StyledPageFooterArea>
                            <PageFotterAreaRight>
                                <ApplyAlertButton onClick={onRejection}
                                                  disabled={this.state.rejectionButtonDisabled}>
                                    この申請を却下する
                                </ApplyAlertButton>
                            </PageFotterAreaRight>
                        </StyledPageFooterArea>
                    </ApplyDialogActions>
                </Box>
            </AdminDialog>
        )
    }
}

NatAdminUserRegistrationApplyRejectionDialog.contextType = AppAdminContext
